import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";
import "../TablesBasePage/TablesBasePage.scss";

const traggliederHeaderDefinitions = {
  header: [
    {
      columns: [
        //Tragglied
        {
          title: "name",
          path: "name",
          disabled: true,
          filtered: false,
          type: "string",
          translationKey: "tables.tragglieder.name",
          translationNamespace: "tables",
        },
        //Kantenlänge
        {
          title: "kantenlaenge",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.kantenlaenge",
          translationNamespace: "tables",
        },
        //Dicke
        {
          title: "dicke",
          path: "kopfkonstruktion.dicke",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.dicke",
          translationNamespace: "tables",
        },
        //HDPE
        {
          title: "hdpe",
          path: "uebergangsrohr.hdpe_rohr.wanddicke",
          disabled: false,
          filtered: false,
          type: "number",
          valuetype: "string",
          translationKey: "tables.tragglieder.hdpe",
          translationNamespace: "tables",
        },
        //STAHL
        {
          title: "stahl",
          path: "uebergangsrohr.stahlrohr.wanddicke",
          disabled: false,
          filtered: false,
          type: "number",
          valuetype: "string",
          translationKey: "tables.tragglieder.stahl",
          translationNamespace: "tables",
        },

        //Zug
        {
          span: 2,
          title: "zug",
          path: "uebergangsrohr.min_lb_zug",
          disabled: false,
          filtered: false,
          type: "number",
          valuetype: "string",
          translationKey: "tables.tragglieder.zug",
          translationNamespace: "tables",
        },

        //Druck
        {
          span: 2,
          title: "druck",
          path: "uebergangsrohr.min_lb_druck",
          disabled: false,
          filtered: false,
          type: "number",
          valuetype: "string",
          translationKey: "tables.tragglieder.druck",
          translationNamespace: "tables",
        },

        //kopfkonstruktion.einbindung_fundament
        {
          title: "einbindung_fundament",
          path: "kopfkonstruktion.einbindung_fundament",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.einbindung_fundament",
          translationNamespace: "tables",
        },
        //kopfkonstruktion.abstand_uebergangsrohr
        {
          title: "abstand_uebergangsrohr",
          path: "kopfkonstruktion.abstand_uebergangsrohr",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.abstand_uebergangsrohr",
          translationNamespace: "tables",
        },

        //bewehrung oben
        {
          span: 2,
          title: "bewehrung_oben",
          //path: "obere_zusatzbewehrung.n",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.bewehrung_oben",
          translationNamespace: "tables",
        },

        //bewehrung unten
        {
          span: 2,
          title: "bewehrung_unten",
          //path: "untere_zusatzbewehrung.n",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.bewehrung_unten",
          translationNamespace: "tables",
        },
      ],
    },
    {
      columns: [
        //Tragglied
        {
          title: "",
          path: "name",
          disabled: true,
          filtered: false,
          type: "string",
        },
        //Kantenlänge
        {
          title: "kantenlaenge_f",
          path: "kopfkonstruktion.kantenlaenge",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.kantenlaenge_f",
          translationNamespace: "tables",
        },
        //Plattendicke
        {
          title: "dicke_f",
          path: "kopfkonstruktion.dicke",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.dicke_f",
          translationNamespace: "tables",
        },
        //HDPE
        {
          title: "hdpe_f",
          path: "uebergangsrohr.hdpe_rohr.wanddicke",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.hdpe_f",
          translationNamespace: "tables",
        },
        //Stahl
        {
          title: "stahl_f",
          path: "uebergangsrohr.stahlrohr.wanddicke",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.stahl_f",
          translationNamespace: "tables",
        },
        //uebergangsrohr.laenge
        {
          title: "laenge_f",
          path: "uebergangsrohr.laenge_zug",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.laenge_f",
          translationNamespace: "tables",
        },
        //uebergangsrohr.min_lb_zug
        {
          title: "min_lb_zug_f",
          path: "uebergangsrohr.min_lb_zug",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.min_lb_zug_f",
          translationNamespace: "tables",
        },
        //uebergangsrohr.laenge
        {
          title: "laenge_f",
          path: "uebergangsrohr.laenge_druck",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.laenge_f",
          translationNamespace: "tables",
        },
        //uebergangsrohr.min_lb_druck
        {
          title: "min_lb_druck_f",
          path: "uebergangsrohr.min_lb_druck",
          disabled: false,
          filtered: false,
          type: "string",
          valuetype: "number",
          translationKey: "tables.tragglieder.min_lb_druck_f",
          translationNamespace: "tables",
        },
        // kopfkonstruktion.einbindung_fundament
        {
          title: "einbindung_fundament_f",
          path: "kopfkonstruktion.einbindung_fundament",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.einbindung_fundament_f",
          translationNamespace: "tables",
        },
        //kopfkonstruktion.abstand_uebergangsrohr
        {
          title: "abstand_uebergangsrohr_f",
          path: "kopfkonstruktion.abstand_uebergangsrohr",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.abstand_uebergangsrohr_f",
          translationNamespace: "tables",
        },
        //bewehrung oben
        //obere_zusatzbewehrung.n
        {
          title: "n",
          path: "obere_zusatzbewehrung.n",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.n",
          translationNamespace: "tables",
        },
        //obere_zusatzbewehrung.durchmesser
        {
          title: "durchmesser_f",
          path: "obere_zusatzbewehrung.durchmesser",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.durchmesser_f",
          translationNamespace: "tables",
        },
        //bewehrung unten
        //untere_zusatzbewehrung.n
        {
          title: "n",
          path: "untere_zusatzbewehrung.n",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.n",
          translationNamespace: "tables",
        },
        //untere_zusatzbewehrung.durchmesser
        {
          title: "durchmesser_f",
          path: "untere_zusatzbewehrung.durchmesser",
          type: "string",
          valuetype: "number",
          disabled: false,
          filtered: false,
          translationKey: "tables.tragglieder.durchmesser_f",
          translationNamespace: "tables",
        },
      ],
    },
    {
      columns: [
        //Tragglied
        {
          disabled: true,
          filtered: false,
        },
        //Kantenlänge
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //Plattendicke
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //HDPE
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //Stahl
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //uebergangsrohr.laenge
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //uebergangsrohr.min_lb_zug
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //uebergangsrohr.laenge
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //uebergangsrohr.min_lb_druck
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        // kopfkonstruktion.einbindung_fundament
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //kopfkonstruktion.abstand_uebergangsrohr
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //bewehrung oben
        //obere_zusatzbewehrung.n
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.lagen",
          translationNamespace: "tables",
        },
        //obere_zusatzbewehrung.durchmesser
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
        //bewehrung unten
        //untere_zusatzbewehrung.n
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.lagen",
          translationNamespace: "tables",
        },
        //untere_zusatzbewehrung.durchmesser
        {
          disabled: false,
          filtered: false,
          translationKey: "tables.units.mm",
          translationNamespace: "tables",
        },
      ],
    },
  ],
};

export default function Kopfkonstruktion({ functions: traggliederFunctions }) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;

  const { isLoading, data: elements } = traggliederFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <p>loading ...</p>;
  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader
                headerDefs={traggliederHeaderDefinitions}
                translationPrefix={"tables.tragglieder"}
              />
              <TableBody
                columns={traggliederHeaderDefinitions.header[1].columns}
                currentTableData={currentTableData}
                functions={traggliederFunctions}
              />
            </>
          )}
        </table>
      </div>

      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
